import { useCentralPaymentPolicyOptions } from '../../queries/useCentralPaymentPolicyOptions';
import { useCentralCancellationPolicyOptions } from '../../queries/useCentralCancellationPolicyOptions';
import { CentralCreatePolicyLinks } from '../../DefaultPolicyForm/CentralCreatePolicyLinks';
import { PolicyFields } from './PolicyFields';

interface CentralPolicyFieldsProps {
    bookablePeriod?: 'Month' | 'Night' | 'Day' | 'Hour';
}

export const CentralPolicyFields = ({ bookablePeriod }: CentralPolicyFieldsProps) => {
    const paymentPolicyOptionsQuery = useCentralPaymentPolicyOptions();
    const cancellationPolicyOptionsQuery = useCentralCancellationPolicyOptions({ bookablePeriod });
    return (
        <>
            <PolicyFields
                paymentPolicyOptionsQuery={paymentPolicyOptionsQuery}
                cancellationPolicyOptionsQuery={cancellationPolicyOptionsQuery}
            />
            <CentralCreatePolicyLinks />
        </>
    );
};
